<div class="container-fluid">
    <div class="edit-profile">
        <div class="row">
            <div class="col-xl-4">
                <div class="card title-line">
                    <div class="card-header">
                        <h2 class="card-title mb-0">Mi Perfil</h2>
                        <div class="card-options"><a class="card-options-collapse"  href="javascript:void(0)" data-bs-toggle="card-collapse"><i class="fe fe-chevron-up"></i></a><a class="card-options-remove"  href="javascript:void(0)" data-bs-toggle="card-remove"><i class="fe fe-x"></i></a></div>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="clientForm">
                            <div class="row g-3">
                                <div class="col-12">
                                    <div class="profile-title"><img class="img-70 rounded-circle" alt="" src="assets/img/profile/user.png">
                                        <div class="flex-grow-1">
                                            <h3 class="mb-1 f-w-600">{{ this.dataClient.client.name }}</h3>
                                            <p>Cliente</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <label class="form-label">Email Address</label>
                                    <input class="form-control" type="email" placeholder="your-email@domain.com"
                                           [class.is-invalid]="clientForm.get('email')?.touched && clientForm.get('email')?.invalid"
                                           formControlName="email">
                                    <div *ngIf="clientForm.get('email')?.touched && clientForm.get('email')?.invalid" class="invalid-feedback">
                                        Ingrese un correo válido.
                                    </div>
                                </div>

                                <div class="form-footer d-flex">
                                    <button class="btn btn-secondary me-2" (click)="changePass()">Cambiar contraseña</button>
                                    <button class="btn btn-primary" (click)="sendClient()">Actualizar</button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-8">
                <form class="card" [formGroup]="dataForm">
                    <div class="card-header">
                        <h2 class="card-title mb-0">Editar Perfil</h2>
                        <div class="card-options">
                            <a class="card-options-collapse"  href="javascript:void(0)" data-bs-toggle="card-collapse">
                                <i class="fe fe-chevron-up"></i>
                            </a>
                            <a class="card-options-remove"  href="javascript:void(0)" data-bs-toggle="card-remove">
                                <i class="fe fe-x"></i>
                            </a>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row g-3">
                            <div class="col-md-5">
                                <label class="form-label">Nombre</label>
                                <input class="form-control" type="text" placeholder="" [class.is-invalid]="dataForm.get('name')?.touched && dataForm.get('name')?.invalid"
                                       formControlName="name">
                                <div *ngIf="dataForm.get('name')?.touched && dataForm.get('name')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-3">
                                <label class="form-label">Móvil</label>
                                <input class="form-control" type="text" placeholder="10 dígitos" [class.is-invalid]="dataForm.get('movil')?.touched && dataForm.get('movil')?.invalid"
                                       formControlName="movil">
                                <div *ngIf="dataForm.get('movil')?.touched && dataForm.get('movil')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-4">
                                <label class="form-label">Teléfono</label>
                                <input class="form-control" type="text" placeholder="10 dígitos" [class.is-invalid]="dataForm.get('telefono')?.touched && dataForm.get('telefono')?.invalid"
                                       formControlName="telefono">
                                <div *ngIf="dataForm.get('telefono')?.touched && dataForm.get('telefono')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <label class="form-label">País</label>
                                <select class="form-select"
                                        [class.is-invalid]="dataForm.get('pais')?.touched && dataForm.get('pais')?.invalid"
                                        formControlName="pais">
                                    <option [ngValue]="null" disabled selected>Categoría vehículo</option>
                                    <option *ngFor="let item of countryList" [value]="item.id">{{ item.value }}</option>
                                </select>
                                <div *ngIf="dataForm.get('pais')?.touched && dataForm.get('pais')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <div class="col-sm-6 col-md-6">
                                <label class="form-label">Ciudad</label>
                                <select class="form-select"
                                        [class.is-invalid]="dataForm.get('ciudad')?.touched && dataForm.get('ciudad')?.invalid"
                                        formControlName="ciudad">
                                    <option [ngValue]="null" disabled selected>Categoría vehículo</option>
                                    <option *ngFor="let item of cityList" [value]="item.id">{{ item.value }}</option>
                                </select>
                                <div *ngIf="dataForm.get('ciudad')?.touched && dataForm.get('ciudad')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label">Uso común</label>
                                <select class="form-select"
                                        [class.is-invalid]="dataForm.get('uso_comun_servicio')?.touched && dataForm.get('uso_comun_servicio')?.invalid"
                                        formControlName="uso_comun_servicio">
                                    <option [ngValue]="null" disabled selected>Categoría vehículo</option>
                                    <option *ngFor="let item of useList" [value]="item.id">{{ item.value }}</option>
                                </select>
                                <div *ngIf="dataForm.get('uso_comun_servicio')?.touched && dataForm.get('uso_comun_servicio')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <label class="form-label">Regímen fiscal</label>
                                <select class="form-select"
                                        [class.is-invalid]="dataForm.get('regimen_fiscal')?.touched && dataForm.get('regimen_fiscal')?.invalid"
                                        formControlName="regimen_fiscal">
                                    <option [ngValue]="null" disabled selected>Categoría vehículo</option>
                                    <option *ngFor="let item of regimenList" [value]="item.id">{{ item.value }}</option>
                                </select>
                                <div *ngIf="dataForm.get('regimen_fiscal')?.touched && dataForm.get('regimen_fiscal')?.invalid" class="invalid-feedback">
                                    Ingrese un valor válido.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-end">
                        <button class="btn btn-primary" type="button" (click)="sendData()">Actualizar Perfil</button>
                    </div>
                </form>
            </div>
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <h2 class="card-title mb-0">Datos de facturación</h2>
                        <button class="btn btn-primary" type="button" (click)="newRow()">Nueva</button>
                    </div>

                    <div class="table-responsive add-project custom-scrollbar">
                        <table class="table card-table table-vcenter text-nowrap">
                            <thead>
                            <tr>
                                <th> <span class="f-light f-w-600">ID</span></th>
                                <th> <span class="f-light f-w-600">Razón social (Lista)</span></th>
                                <th> <span class="f-light f-w-600">RFC</span></th>
                                <th> <span class="f-light f-w-600">Dirección fiscal</span></th>
                                <th> <span class="f-light f-w-600">CP</span></th>
                                <th> <span class="f-light f-w-600">Uso CFDI</span></th>
                                <th> <span class="f-light f-w-600">Correo electrónico adicional</span></th>
                                <th> <span class="f-light f-w-600">Constancia de situación fiscal</span></th>
                                <th> <span class="f-light f-w-600">Opciones</span></th>
                            </tr>
                            </thead>
                            <tbody>
                                @for (item of dataClient.billing; track item) {
                                    <tr>
                                        <td> <a class="" href="javascript:void(0)">{{item.id}}</a></td>
                                        <td> <span class="f-light">{{item.legal_names}}</span></td>
                                        <td> <span class="txt-success">{{item.rfc}}</span></td>
                                        <td> <span class="f-light">{{item.billing_address}}</span></td>
                                        <td><span class="f-light">{{item.cp}}</span></td>
                                        <td><span class="f-light">{{item.use_cfdi}}</span></td>
                                        <td><span class="f-light">{{item.additional_email}}</span></td>
                                        <td>
                                            <div class="file-content">
                                                <ul class="files">
                                                    <li class="file-box">
                                                        <div class="file-top" (click)="downloadPDF(item.tax_status_certificate_url)"> <i class="fa fa-file-image-o txt-primary2"></i></div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="product-action">
                                                <button class="btn btn-sm" (click)="editRow(item)">
                                                    <app-common-svg-icons [icons]="'edit-content'"></app-common-svg-icons>
                                                </button>
                                                <button class="btn btn-sm" (click)="deleteRow(item)">
                                                    <app-common-svg-icons [icons]="'trash1'"></app-common-svg-icons>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                }
                                @if (dataClient.billing.length == 0){
                                    <tr>
                                        <td colspan="9" class="text-center">
                                            Sin registros
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<br>
<br>
